<template>
  <div class="indexPage">
    <header class="heardController">
      <div @click="$router.push({ name: 'Home' })" class="title">
        云南省建设工程材料及设备信息登记
      </div>
      <div
        v-if="$store.state.token === null"
        @click="$router.push({ name: 'LoginIndex' })"
        class="btn userLogin"
      >
        <img src="../assets/user.png" class="ico" />
        <div class="text">企业登录</div>
      </div>
      <div
        v-else
        @click="$router.push({ name: 'AgentInfo' })"
        class="btn userLogin"
      >
        <img src="../assets/user.png" class="ico" />
        <div class="text">用户中心</div>
      </div>
      <div class="btn adminLogin marginLeft20">
        <img src="../assets/adm.png" class="ico" />
        <div class="text ">
          <a
            href="http://cldjadm.ynbzde.com/admin/index/login"
            class="text-a"
            target="_blank"
            >管理机构登录</a
          >
        </div>
      </div>
    </header>
    <div class="banner">
      <div class="titleController">
        <div class="title">云南省建设工程材料及设备信息登记</div>
        <div class="minitTitle marginTop15">
          助力完成产品编码，实现产品信息一码通
        </div>
      </div>
    </div>
    <!--导航切换-->
    <div class="tabController width1200 marginTop30">
      <div
        v-if="false"
        class="title"
        :class="search.status === 3 ? 'act' : ''"
        @click="typeBtn(3)"
      >
        入库产品
      </div>
      <div
        class="title"
        :class="search.status === 5 ? 'act' : ''"
        @click="typeBtn(5)"
      >
        公示中产品
      </div>
      <div
        class="title"
        :class="search.status === 6 ? 'act' : ''"
        @click="typeBtn(6)"
      >
        已赋码产品
      </div>
    </div>
    <div class="tongzhigonggaoList">
      <div style="flex:1;"></div>
      <img src="../assets/zhiliang.png" v-if="false" />
      <div @click="qualityDialog" v-if="false" class="t zl">
        质量监督
      </div>
      <img src="../assets/ico.png" />
      <div
        @click="
          $router.push({
            name: 'News'
          })
        "
        class="t"
      >
        通知公告
      </div>
    </div>
    <div class="mainController">
      <!--搜索框区域-->
      <div class="soController">
        <img class="logo" src="../assets/img/soIco.png" />
        <div class="textController marginLeft15">
          <div class="bigText">查询材料及设备</div>
          <div class="miniText">您可以查询正在公示中和已登记的材料及设备</div>
        </div>
        <div class="soInputController">
          <i class="el-icon-search soBtn"></i>
          <input
            class="soInput marginLeft15"
            type="text"
            v-model="search.keywords"
            @keyup.enter="enterDown"
            placeholder="请输入产品名称/产品编号/企业名称"
          />
        </div>
      </div>
      <div class="tableController">
        <el-table
          v-if="search.status === 3"
          :data="tableData"
          style="width: 100%"
          header-row-class-name="indexHeardercController"
          :row-class-name="tableRowClassName"
        >
          <el-table-column prop="name" label="产品类型"> </el-table-column>
          <el-table-column prop="product_name" label="产品名称">
          </el-table-column>
          <el-table-column prop="mspec" label="规格型号"> </el-table-column>
          <el-table-column prop="company_name" label="生产厂商名称">
          </el-table-column>
          <el-table-column prop="show_time" label="入库时间"> </el-table-column>
        </el-table>
        <el-table
          v-if="search.status === 5"
          :data="tableData"
          style="width: 100%"
          header-row-class-name="indexHeardercController"
          :row-class-name="tableRowClassName"
        >
          <el-table-column prop="name" label="产品类型"> </el-table-column>
          <el-table-column prop="product_name" label="产品名称">
          </el-table-column>
          <el-table-column prop="mspec" label="规格型号"> </el-table-column>
          <el-table-column prop="company_name" label="生产厂商名称">
          </el-table-column>
          <el-table-column prop="show_time" label="公示开始时间">
          </el-table-column>
          <el-table-column prop="end_time" label="公示结束时间">
          </el-table-column>
        </el-table>
        <el-table
          v-if="search.status === 6"
          :data="tableData"
          style="width: 100%"
          header-row-class-name="indexHeardercController"
          :row-class-name="tableRowClassName"
        >
          <el-table-column prop="name" label="产品类型"> </el-table-column>
          <el-table-column prop="product_name" label="产品名称">
          </el-table-column>
          <el-table-column prop="mspec" label="规格型号"> </el-table-column>
          <el-table-column prop="company_name" label="生产厂商名称">
          </el-table-column>
          <el-table-column prop="codetime" label="登记时间"> </el-table-column>
          <el-table-column prop="opereate" label="操作" width="100">
            <template slot-scope="scope" v-if="search.status === 6">
              <el-button @click="viewcert(scope.row)" type="text" size="small">
                查看证书
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="marginTop20" style="text-align: right;">
          <el-pagination
            background
            layout="total,prev, pager, next"
            :total="total"
            :page-size="pageSize"
            :current-page="page"
            @current-change="changePage"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <footer class="footerController marginTop20">
      指导单位 | 云南省住房和城乡建设厅科技与标准定额处
      <div class="footChengkai"></div>
      主办单位 | 云南省工程建设技术经济室
      <div class="footChengkai"></div>
      联系电话 0871-68183040 15887247294 <br />
      技术支持 | 昆明行列科技有限公司 13095322247
      <div class="footChengkai"></div>
      备案号
      <a
        class="icp-num"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        >滇ICP备18001273号-1</a
      >
    </footer>
    <!--下面是飘窗-->
    <Piaochuang
      v-for="(val, ind) in piaochuangList"
      :key="ind"
      :href="val.href"
      :src="val.dom_image"
      :width="val.width"
      :height="val.heigh"
    ></Piaochuang>
    <el-dialog
      title="质量反馈"
      :visible.sync="qualityAvailable"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        :width="40"
      >
        <el-form-item label="企业名称" prop="company_name">
          <el-input v-model="ruleForm.company_name"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contact_name">
          <el-input v-model="ruleForm.contact_name"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contact_tel">
          <el-input v-model="ruleForm.contact_tel"></el-input>
        </el-form-item>
        <el-form-item label="附件上传" prop="back_file">
          <a
            download="监督反馈意见模板.docx"
            :href="apiDomian + 'assets/file/feedtemplate.docx'"
            >下载质量反馈模板</a
          >
          <Up v-model="ruleForm.back_file"></Up>
          <a
            v-if="ruleForm.back_file.length === 1"
            target="_blank"
            class="up-file"
            :href="
              ruleForm.back_file.length === 1
                ? ruleForm.back_file[0]['viewurl']
                : ''
            "
          >
            上传的文件
          </a>
          <i
            v-if="ruleForm.back_file.length === 1"
            title="删除"
            @click="ruleForm.back_file = []"
            class="el-icon-delete del"
          ></i>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Up from "@/components/Up.vue";
import Api from "@/plugins/axios.js";
import Piaochuang from "@/components/Piaochuang.vue";
export default {
  name: "Home",
  components: {
    Piaochuang,
    Up
  },
  data() {
    return {
      apiDomian: Api.domain,
      pageSize: 0, // 每页显示条目数
      total: 0, // 总数
      page: 1, // 当前页码
      piaochuangList: [], // 飘窗列表
      search: {
        keywords: "",
        status: 5 // 列表页查询状态
      },
      data: {},
      tableData: [], // 表格数据状态
      qualityAvailable: false,
      ruleForm: {
        company_name: "",
        contact_name: "",
        contact_tel: "",
        back_file: []
      },
      rules: {
        company_name: [{ required: true, message: "请填写", trigger: "blur" }],
        contact_name: [{ required: true, message: "请填写", trigger: "blur" }],
        contact_tel: [{ required: true, message: "请填写", trigger: "blur" }],
        back_file: [{ required: true, message: "请上传文件", trigger: "blur" }]
      },
      formLabelWidth: "120px"
    };
  },
  async mounted() {
    // 获得飘窗
    const li = await Api.getPiaochuang();
    this.piaochuangList = li;
    this.getData();
    console.log(Api.domain, "------------------>");
  },
  methods: {
    //查看证书
    viewcert(row) {
      ///card?uuid=2c76cc95-6551-4631-b8a0-ebeebefd5dff&agentType=1&type=look
      const uuid = row.agent_type == 1 ? row.u_uuid : row.at_uuid;
      let jumpUrl = this.$router.resolve({
        path: "/card",
        query: { uuid: uuid, agentType: row.agent_type, type: "look" }
      });
      window.open(jumpUrl.href, "_blank");
    },
    // 修改当前页码
    changePage(page) {
      this.page = page;
      this.getData();
    },
    // 获取首页数据
    async getData() {
      try {
        const data = await Api.getHomeData(
          this.search.status,
          this.search.keywords,
          this.page
        );
        this.pageSize = data.per_page;
        this.data = data;
        this.total = data.total;
        this.tableData = data.data;
      } catch (error) {
        this.loading = false;
        this.$msgbox({ title: "提示", type: "error", message: error });
      }
    },
    typeBtn(status) {
      console.log(status);
      this.page = 1;
      this.search.status = status;
      this.getData();
    },
    enterDown(ev) {
      if (ev.keyCode === 13) {
        this.page = 1;
        this.getData();
      }
    },
    // 表格样式的回调函数
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 != 0) {
        return "indexTableLint";
      } else {
        return "";
      }
    },
    //质量监督弹框
    qualityDialog() {
      this.qualityAvailable = true;
      //this.$refs.ruleForm.resetFields();
    },
    async submitForm(formName) {
      let havali = false;
      this.$refs[formName].validate(valid => {
        if (valid) {
          havali = true;
        }
      });
      let fileurl =
        this.ruleForm.back_file.length === 1
          ? this.ruleForm.back_file[0].url
          : "";
      try {
        if (havali) {
          await Api.feedBack(
            this.ruleForm.company_name,
            this.ruleForm.contact_name,
            this.ruleForm.contact_tel,
            fileurl
          );
          this.$refs[formName].resetFields();
          this.qualityAvailable = false;
          this.$msgbox({
            title: "提示",
            type: "success",
            message: "提交成功，我们将尽快与您联系"
          });
        }
      } catch (error) {
        this.$msgbox({ title: "提示", type: "error", message: error });
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style>
.el-table .indexTableLint {
  background-color: #f0f8fa;
}
</style>
<style lang="less">
.indexHeardercController {
  color: rgba(102, 102, 102, 1);
}
</style>
<style lang="less" scoped>
.indexPage {
  background-color: #f7f7f7;
  min-height: 100vh;
}
// 1200 的宽度
.width1200 {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
// 头
.heardController {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0px 60px;
  background-color: #f7f7f7;
  .title {
    font-size: 24px;
    font-weight: 600;
    color: rgba(13, 86, 129, 1);
    opacity: 1;
    flex: 1;
    cursor: pointer;
  }
  .btn {
    padding: 0px 20px;
    width: 150px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    display: flex;
    align-items: center;
    cursor: pointer;
    .ico {
      height: 25px;
      width: 25px;
    }
    .text {
      color: rgba(255, 255, 255, 1);
      margin-left: 16px;
      font-weight: 400;
      font-size: 14px;
    }
    .text-a {
      color: rgba(255, 255, 255, 1);
      text-decoration: none;
    }
  }
  .userLogin {
    background: #00b1ff;
  }
  .adminLogin {
    background: rgba(0, 130, 164, 1);
  }
}
// 幻灯片区域
.banner {
  height: 340px;
  background-image: url(../assets/coverBg.png);
  background-size: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .titleController {
    width: 1200px;
    .title {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      opacity: 1;
    }
    .minitTitle {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 24px;
      color: rgba(255, 255, 255, 1);
      opacity: 1;
    }
  }
}
// 页脚区域
.tabController {
  display: flex;
  justify-content: center;
  .title {
    cursor: pointer;
    margin-left: 66px;
    font-size: 24px;
    font-weight: 600;
    opacity: 1;
    padding-bottom: 2px;
    color: rgba(153, 153, 153, 1);
  }
  .title:first-child {
    margin-left: 0px;
  }
  .act {
    color: rgba(51, 51, 51, 1);
    border-bottom: 2px solid rgba(29, 120, 211, 1);
  }
}
// 内容区域
.mainController {
  width: 1200px;
  background: rgba(255, 255, 255, 1);
  opacity: 1;
  border-radius: 4px;
  margin: auto;
  margin-top: 10px;
  // 搜索框
  .soController {
    height: 80px;
    background: rgba(0, 130, 164, 1);
    opacity: 1;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0px 30px;
    .logo {
      width: 50px;
      height: 50px;
    }
    .textController {
      flex: 1;
      .bigText {
        font-size: 16px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        opacity: 1;
      }
      .miniText {
        width: 240px;
        height: 17px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        opacity: 1;
      }
    }
    // 搜索框
    .soInputController {
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(227, 227, 227, 1);
      opacity: 1;
      border-radius: 6px;
      width: 680px;
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0px 22px;
      .soBtn {
        font-size: 24px;
        color: #333333;
      }
      .soInput {
        flex: 1;
        border: 0px;
        font-size: 12px;
      }
    }
  }
  // 表格
  .tableController {
    padding: 0px 31px 51px 31px;
  }
}
// 页脚
.footerController {
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  color: rgba(51, 51, 51, 1);
  opacity: 1;
  .icp-num {
    text-decoration: none;
    color: #333333;
  }
}
// 通知公告
.tongzhigonggaoList {
  display: flex;
  color: #036eb8;
  align-items: center;
  width: 1200px;
  margin: auto;
  img {
    cursor: pointer;
    margin-top: 3px;
    margin-right: 5px;
  }
  .t {
    cursor: pointer;
  }
  .zl {
    margin-right: 20px;
    cursor: pointer;
  }
}
.demo-ruleForm {
  /deep/ .el-input__inner {
    width: 300px;
  }
  .up-file {
    color: #0082a4;
    text-decoration: none;
  }
}
.sub-btn {
  display: inline-block;
  cursor: pointer;
  margin-left: auto;
  margin-right: auto;
  padding: 0px 20px;
  height: 40px;
  border-radius: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  border: 1px solid #0082a4;
  color: #0082a4;
  opacity: 1;
  text-align: center;
}
</style>
